import { ActividadMultiSelect } from 'components/domain/ActividadMultiSelect'
import { RecursoEducativoMultiSelect } from 'components/domain/RecursoEducativoMultiSelect'
import { FileUploadIcon } from 'components/shared/Icons'
import { cn } from 'lib/utils'
import { useRef, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'

export default function ModalEndClass({ show, onHide, loading, onEndClass }) {
    const fileRef = useRef(null)
    const [values, setValues] = useState({ descripcion: '', actividades: [], recursos_educativos: [] })
    const [errors, setErrors] = useState({ descripcion: '', file: '' })

    const handleEndClass = () => {
        if (validateFile()) {
            if (validateDescripcion(values.descripcion)) {
                const file = fileRef.current?.files.length > 0 ? fileRef.current.files[0] : undefined
                onEndClass({ ...values, file })
            }
        }
    }
    const handleChange = (e) => {
        const { name, value } = e.target
        setValues((prev) => ({ ...prev, [name]: value }))
        if (errors[name]) setErrors((prev) => ({ ...prev, [name]: '' }))
    }
    const validateDescripcion = (value) => {
        let isValid = true
        if (value.trim()) {
            if (value.length > 500) {
                setErrors({ ...errors, descripcion: 'Longitud máxima de 500 caracteres' })
                isValid = false
            }
        } else {
            setErrors({ ...errors, descripcion: 'Requerido' })
            isValid = false
        }
        isValid && errors.descripcion && setErrors({ ...errors, descripcion: '' })
        return isValid
    }
    const validateFile = () => {
        let isValid = true
        const file = fileRef.current?.files.length > 0 ? fileRef.current.files[0] : undefined
        if (file) {
            let ext = file.name.substring(file.name.length - 5)
            ext = ext.charAt(0) === '.' ? ext : ext.substring(1)
            if (!['.pdf', '.doc', '.docx', '.png', '.jpg', '.jpeg'].includes(ext)) {
                setErrors({
                    ...errors,
                    file: 'Formato de archivo no valido. Solo se permiten archivos pdf, doc, docx, png, jpg y jpeg',
                })
                isValid = false
            } else {
                errors.file && setErrors({ ...errors, file: '' })
            }
        } else {
            errors.file && setErrors({ ...errors, file: '' })
        }
        return isValid
    }

    return (
        <Modal show={show} centered>
            <Modal.Header>
                <span className='h5 mb-0'>Terminar clase</span>
            </Modal.Header>
            <Modal.Body>
                <div className='mb-3'>
                    <label className='form-label'>
                        Contenido Avanzado <span className='text-danger'>*</span>
                    </label>
                    <textarea
                        name='descripcion'
                        value={values.descripcion}
                        onChange={handleChange}
                        placeholder='Descripción de actividades realizadas en la clase'
                        className={cn('form-control', errors.descripcion && 'is-invalid')}
                    />
                    <div className='invalid-feedback'>{errors.descripcion}</div>
                </div>

                <div className='mb-3'>
                    <label className='form-label'>Actividades</label>
                    <ActividadMultiSelect
                        name='actividades'
                        value={values.actividades}
                        onChange={handleChange}
                        multiSelection
                        valueAsOption
                    />
                </div>
                <div className='mb-3'>
                    <label className='form-label'>Recursos utilizados</label>
                    <div className='position-relative'>
                        <RecursoEducativoMultiSelect
                            name='recursos_educativos'
                            value={values.recursos_educativos}
                            onChange={handleChange}
                            multiSelection
                            valueAsOption
                            menuStyle={{ width: '100%' }}
                        />
                    </div>
                </div>

                <span className='text-primary'>* Opcionalmente puede adjuntar un archivo</span>
                <label className='custom-file' htmlFor='file'>
                    <span className='custom-file-icon'>
                        <FileUploadIcon />
                    </span>
                    {fileRef.current?.files.length > 0 ? fileRef.current.files[0].name : 'Seleccionar archivo'}
                </label>
                <input
                    ref={fileRef}
                    type='file'
                    id='file'
                    accept='.pdf,.doc,.docx,.jpg,.png,.jpeg'
                    hidden
                    onChange={validateFile}
                />
                {errors.file && <div className='msg-error mt-1'>{errors.file}</div>}
            </Modal.Body>

            <Modal.Footer>
                <Button variant='danger' onClick={onHide} disabled={loading}>
                    Cancelar
                </Button>
                <Button variant='blue' onClick={handleEndClass} disabled={loading}>
                    Terminar
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
